// src/tasks/UserTasks.jsx
import { useEffect, useState } from "react";
import api from "../../api";
import { Table, Form, Badge } from "react-bootstrap";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import gregorian from "react-date-object/calendars/gregorian";
import persian_fa from "react-date-object/locales/persian_fa";

const TASK_STATUS_LABELS = {
  assigned: "اختصاص داده شده",
  in_progress: "در حال انجام",
  completed: "تکمیل شده",
};

// تبدیل اعداد فارسی به انگلیسی (برای رشته‌های تاریخ دریافتی از API)
const toEnglishDigits = (str) =>
  String(str).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

const formatDeadlineToPersian = (deadline) => {
  if (!deadline) return "-";

  const englishDeadline = toEnglishDigits(deadline);

  // deadline ورودی را میلادی فرض می‌کنیم، سپس به شمسی تبدیل می‌کنیم
  return new DateObject({
    date: englishDeadline,
    calendar: gregorian,
    locale: persian_fa,
  })
    .convert(persian)
    .format("YYYY/MM/DD");
};

const UserTasks = () => {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    api.get("/tasks/").then((res) => {
      const data = Array.isArray(res.data)
        ? res.data
        : res.data?.results ?? [];
      setTasks(data);
    });
  }, []);

  const changeStatus = (id, status) => {
    api.patch(`/tasks/${id}/`, { status }).then(() => {
      setTasks((prev) => prev.map((t) => (t.id === id ? { ...t, status } : t)));
    });
  };

  return (
    <>
      {tasks.length === 0 ? (
        <p className="text-muted">هیچ تسکی وجود ندارد</p>
      ) : (
        <Table striped bordered hover responsive className="align-middle mt-3">
          <thead>
            <tr>
              <th style={{ width: "25%" }}>عنوان</th>
              <th>توضیحات</th>
              <th>سررسید</th>
              <th style={{ width: "170px" }}>وضعیت</th>
              <th style={{ width: "200px" }}>تغییر وضعیت</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => (
              <tr key={task.id}>
                <td className="fw-semibold">{task.title}</td>

                <td className="text-muted small">{task.description || "—"}</td>

                <td>{formatDeadlineToPersian(task.deadline)}</td>

                <td>
                  <Badge
                    bg={
                      task.status === "completed"
                        ? "success"
                        : task.status === "in_progress"
                        ? "warning"
                        : "secondary"
                    }
                  >
                    {TASK_STATUS_LABELS[task.status]}
                  </Badge>
                </td>

                <td>
                  <Form.Select
                    size="sm"
                    value={task.status}
                    onChange={(e) => changeStatus(task.id, e.target.value)}
                  >
                    <option value="assigned">اختصاص داده شده</option>
                    <option value="in_progress">در حال انجام</option>
                    <option value="completed">تکمیل شده</option>
                  </Form.Select>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default UserTasks;